// Package imports:
import React, { useContext, useMemo } from 'react';
// Service imports:
import { useFetchedApiLmdData } from '../../../services/apiHooks';
// Type imports:
import { ICompanyViewModel } from '../../../types/CompanyTypes';
// Context imports:
import { AccessTokenContext } from '../../../contexts/AccessTokenContext';
import Loading from '../../../ui-elements/Loading/Loading';
// Component imports:

interface ICompanyAwards {
    Year: number;
    Isexcellent: boolean;
}

const IMAGE_BASE_URL = "https://cdn.livemarketdata.com/Images/Excellent/";

const CompanyAwards: React.FC<ICompanyViewModel> = ({ id }) => {
    const accessToken = useContext(AccessTokenContext);

    // Fetch data for the company’s awards
    const data = useFetchedApiLmdData<ICompanyAwards[]>(
        id ? `/v1/market_data/v1/keldan/company/excellent_company/ssn/${id}` : null,
        accessToken
    );

    const years = useMemo(() => {
        if (data === null || data instanceof Error) return null;
        return findYearRange(data);
    }, [data]);

    function findYearRange(data: ICompanyAwards[]): string | null {
        let startYear: number | null = null;
        let endYear: number | null = null;

        for (let year = new Date().getFullYear(); year >= 2017; year--) {
            const yearEntry = data.find((entry) => entry.Year === year);
            if (yearEntry && yearEntry.Isexcellent) {
                if (endYear === null) {
                    endYear = year;
                }
                startYear = year;
            } else if (startYear !== null) {
                break;
            }
        }

        if (startYear === endYear) {
            return startYear !== null ? startYear.toString() : null;
        }

        return startYear !== null && endYear !== null
            ? `${startYear}-${endYear}`
            : null;
    }

    const isLoading = data === null;
    const hasError = data instanceof Error;
    return (
        <div className="KCL_company-awards">
            {isLoading && <Loading type="cube" width="100" />}
            {!isLoading && !hasError && years && (
                <a href="/Lists/Excellent">
                    <img
                        src={`${IMAGE_BASE_URL}fyrirmyndar${years}.svg`}
                        alt={`Fyrirmyndarfyrirtæki í rekstri ${years}`}
                        width="800"
                        height="469"
                    />
                </a>
            )}
        </div>
    );
};

export default CompanyAwards;
